import script from "./UTabs.vue?vue&type=script&setup=true&lang=js"
export * from "./UTabs.vue?vue&type=script&setup=true&lang=js"

import "./UTabs.vue?vue&type=style&index=0&id=0c227892&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c227892"]])

export default __exports__